import Cookies from "js-cookie";

const ValidarPermissao = {

    validar(funcionalidadeNome) {
        const tokenCookie = Cookies.get("token");

        if (!tokenCookie) return false;

        try {
            const token = JSON.parse(tokenCookie);
            const funcionalidades = token.funcionalidades;

            if (!Array.isArray(funcionalidades)) return false;

            return funcionalidades.includes(funcionalidadeNome);
        } catch (error) {
            console.error("Erro ao validar permissão:", error);
            return false;
        }
    }
};

export default ValidarPermissao;
